import { AUTH_ROUTE_NAME } from "@/libs/route-name";

export const resetPasswordRoute = () => {
    return {
        name: AUTH_ROUTE_NAME.RESET_PASSWORD,
        path: "/reset-password",
        component: () => import("@/pages/auth/reset-password.vue"),
    }
}